import React, { useRef } from 'react';
import styled from 'styled-components';
import {
    Box,
    Divider,
    Group,
    CloseOutlined,
    ArrowBackOutlined,
    IconButton,
    spacing,
} from '@landr/maestro';
import { t } from '@lingui/macro';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import TextInput from '../../TextInput/TextInput';

const Wrapper = styled(Box)`
    padding: ${spacing('sm')} ${spacing('sm')} ${spacing('none')}
        ${spacing('sm')};
`;

export const IconItem = styled(Group.Item)`
    align-self: start;
    height: ${spacing('xl')};
    margin-top: ${spacing('xxs')};
    margin-bottom: ${spacing('xxs')};
`;

export const _ModalTextInput = ({
    inputRef,
    closeSuggestions,
    isCloseCtaVisible,
    clearCtaLabel,
    handleClearCta,
}: {
    inputRef: React.MutableRefObject<HTMLInputElement | null>;
    closeSuggestions: () => void;
    isCloseCtaVisible: boolean;
    clearCtaLabel: string;
    handleClearCta?: () => void;
}) => (
    <Wrapper>
        <Group direction="vertical" gutter="xs">
            <Group.Item>
                <Group gutter="xxs">
                    <IconItem alignSelf="center">
                        <IconButton
                            icon={ArrowBackOutlined}
                            variant="subtle"
                            kind="link"
                            size="md"
                            label={t`Close`}
                            onClick={closeSuggestions}
                        />
                    </IconItem>
                    <Group.Item flexGrow={10} alignSelf="center">
                        <TextInput ref={inputRef} />
                    </Group.Item>
                    {isCloseCtaVisible && (
                        <Group.Item>
                            <IconButton
                                icon={CloseOutlined}
                                variant="subtle"
                                kind="link"
                                size="md"
                                label={clearCtaLabel}
                                onClick={handleClearCta}
                            />
                        </Group.Item>
                    )}
                </Group>
            </Group.Item>
            <Group.Item>
                <Divider />
            </Group.Item>
        </Group>
    </Wrapper>
);

const ModalTextInput = () => {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const {
        closeSuggestions,
        hasTextInputValue,
        clearCtaLabel,
        handleClearCta,
    } = useSearchBarContext();

    return (
        <_ModalTextInput
            inputRef={inputRef}
            closeSuggestions={closeSuggestions}
            isCloseCtaVisible={hasTextInputValue}
            clearCtaLabel={clearCtaLabel}
            handleClearCta={handleClearCta}
        />
    );
};

export default ModalTextInput;
